import { createFileRoute } from '@tanstack/react-router';
import { SnapshotDetail } from '@features/document-snapshots/SnapshotDetail';

export const Route = createFileRoute('/t/contracts/$snapshotId')({
  validateSearch: (search: Record<string, unknown>) => ({
    review: search.review === true || search.review === 'true',
  }),
  staticData: { breadcrumb: 'Contract Detail', breadcrumbKey: 'K_BREADCRUMB_CONTRACT_DETAIL' },
  component: ContractDetailPage,
});

function ContractDetailPage() {
  const { snapshotId } = Route.useParams();
  const { review } = Route.useSearch();
  return <SnapshotDetail snapshotId={snapshotId} initialReview={review} />;
}
